export default __webpack_public_path__ + "static/media/126_chaorion_kawai0001.eb7e8287.png";